import * as Community from '../constants/Community';
import axios from 'axios';

import * as SG from '../constants/AppSettings';
import { loadStart, loadEnd, noticeAdd } from './App';
import { getMyJoinedCircle } from './User/CircleList'


export function noticeInCommunity(msg, type) {
  return dispatch => {
    dispatch(noticeAdd(msg, type))
  }
}

// コミュニティ作成
export function communityCreate(params, preview=false) {
  return dispatch => {
    dispatch(loadStart());

    axios.post(SG.COMMUNITY_CREATE_URL, params, {
      headers: {
        'Authorization': localStorage.getItem('token'),
        'content-type': 'multipart/form-data'
      }
    })
      .then(function (r) {
        dispatch(loadEnd())
        if (preview) {
          dispatch(communityPreviewSet(r.data.community))
        } else {
          dispatch(communityCreateResult(r.data.community))
          dispatch(noticeAdd('サークルを下書き保存しました', 'success'))
        }
        return {
          type: Community.COMMUNITY_CREATE
        }
      })
      .catch(function () {
        dispatch(noticeAdd('サークルの保存に失敗しました', 'error'))
        dispatch(loadEnd())
        return {
          type: Community.COMMUNITY_CREATE
        }
      });
  }
}

export function communityCreateReset() {
  return {
    type: Community.COMMUNITY_CREATE_RESET
  }
}

export function communityCreateResult(community) {
  return {
    type: Community.COMMUNITY_CREATE_RESULT,
    community
  }
}


// コミュニティUPDATE
export function communityUpdate(formData, communityId, preview=false, draft=false) {
  return dispatch => {
    dispatch(loadStart());
    // console.log('送信', formData)
    axios.put(SG.COMMUNITY_UPDATE_URL.replace(/:id/, communityId), formData, {
        headers: {
          'Authorization': localStorage.getItem('token'),
          'content-type': 'multipart/form-data'
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        let message = 'サークル情報を更新しました'
        if (draft) {
          dispatch(communityCreateResult(r.data.community))
          message = 'サークル情報を下書き保存しました'
        } else {
          dispatch(communityUpdateResult(r.data.community))
        }
        
        if (preview) {
          dispatch(communityPreviewSet(r.data.community))
          dispatch(noticeAdd(message, 'success'))
        } else {
          dispatch(noticeAdd(message, 'success'))
        }
        return {
          type: Community.COMMUNITY_UPDATE
        }
      })
      .catch(function (r) {
        if (r.response && r.response.data && r.response.data.messages) {
          const errors = r.response.data.messages
          if (errors) {
            // const errorMsg = errors.map(error => {
            //   return (
            //     <p className='mb-0'>{error}</p>
            //   )
            // })
            dispatch(noticeAdd(errors, 'error'))
          } else {
            dispatch(noticeAdd('サーバーエラーにより更新が失敗しました。管理者にお問い合わせください。', 'error'))
          }
        } else {
          dispatch(noticeAdd(`サーバーエラーにより更新が失敗しました。管理者にお問い合わせください。 ${r}`, 'error'))
        }
        
        dispatch(loadEnd())
        return {
          type: Community.COMMUNITY_UPDATE
        }
      });
  }
}

export function communityUpdateResult(community) {
  return {
    type: Community.COMMUNITY_UPDATE_RESULT,
    community
  }
}

export function communityUpdateReset() {
  return {
    type: Community.COMMUNITY_UPDATE_RESET
  }
}

export function removeCreatedFlag() {
  return {
    type: Community.COMMUNITY_CREATED_FLAG_REMOVE
  }
}

// コミュニティ詳細取得
export function communityGet(communityId, preview=false) {

  return dispatch => {
    dispatch(loadStart());
    // console.log('コミュニティ情報get')

    let headerParam
    if (!!localStorage.getItem('token')) {
      headerParam = {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      }
    } else {
      headerParam = {}
    }

    axios.get(SG.COMMUNITY_SHOW_URL.replace(/:id/, communityId), headerParam )
      .then(function (r) {
        dispatch(loadEnd())
        if (preview) {
          dispatch(communityGetResult(r.data.community, preview))
        } else {
          dispatch(communityGetResult(r.data.community))
        }
      })
      .catch(function () {
        dispatch(noticeAdd('ページが見つかりませんでした', 'error'))
        dispatch(loadEnd())
        dispatch(communityGetResult(false))
      });
    return {
      type: Community.COMMUNITY_INFO_GET
    }
  }
}

export function communityGetResult(community, preview=false) {
  return {
    type: Community.COMMUNITY_INFO_GET_RESULT,
    community,
    preview
  }
}

export function communityInfoRemove() {
  return {
    type: Community.COMMUNITY_INFO_REMOVE
  }
}


export function communityDestroy(communityId) {
  return dispatch => {
    dispatch(loadStart());
    axios.delete(SG.COMMUNITY_UPDATE_URL.replace(/:id/, communityId), {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(communityDestroyResult(r.data.community))
        dispatch(noticeAdd(r.data.messages[0], 'success'))
        return {
          type: Community.COMMUNITY_DESTROY
        }
      })
      .catch(function () {
        dispatch(noticeAdd('サークル解散失敗', 'error'))
        dispatch(loadEnd())
        return {
          type: Community.COMMUNITY_DESTROY
        }
      });

  }
}

export function communityDestroyResult(message) {
  return {
    type: Community.COMMUNITY_DESTROY_RESULT,
    message
  }
}

export function communityDestroyFlagRemove() {
  return {
    type: Community.COMMUNITY_DESTROY_FLAG_REMOVE
  }
}

export function communityPreviewBack() {
  return {
    type: Community.COMMUNITY_PREVIEW_BACK
  }
}

export function communityPreviewSet(community, formData) {
  return {
    type: Community.COMMUNITY_PREVIEW_SET,
    community,
    formData
  }
}

export function communityPreviewDelete() {
  return {
    type: Community.COMMUNITY_PREVIEW_DELETE
  }
}

export function communityPublish(communityId, approval) {
  return dispatch => {
    dispatch(loadStart());
    axios.put(SG.COMMUNITY_UPDATE_URL.replace(/:id/, communityId), { community: {status: 1, approval: approval}}, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(function (r) {
        dispatch(loadEnd())
        dispatch(communityPublishResult(r.data.community))
        // if (preview) {
        //   dispatch(communityPreviewDelete())
        // } else {
        
        dispatch(noticeAdd('サークルを公開しました', 'success'))
        // }
        

        return {
          type: Community.COMMUNITY_PUBLISH
        }
      })
      .catch(function () {
        dispatch(noticeAdd('サークル公開失敗', 'error'))
        dispatch(loadEnd())
        return {
          type: Community.COMMUNITY_PUBLISH
        }
      });

  }

}

export function communityPublishResult(community) {
  return {
    type: Community.COMMUNITY_PUBLISH_RESULT,
    community
  }
}

// コミュニティ参加申請
export function communityJoin(community_id, card_id) {
  return dispatch => {
    dispatch(loadStart())
    axios.post(SG.COMMUNITY_JOIN_URL.replace(/:id/, community_id), {
      card_id: card_id
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      
      dispatch(noticeAdd(res.data.messages, 'success'))
      dispatch(communityGet(community_id))
      dispatch(communityJoinResult())
      dispatch(loadEnd())
    }).catch(res => {
      dispatch(communityJoinResult())
      if (res.data) {
        dispatch(noticeAdd(res.data.messages, 'error'))
      } else if (res.response && res.response.data && res.response.data.messages) {
        dispatch(noticeAdd(res.response.data.messages, 'error'))
      } else {
        dispatch(noticeAdd('サーバーエラーにより参加に失敗しました。管理者にお問い合わせください', 'error'))
      }
      
      dispatch(loadEnd())
    })
  }
}

export function communityJoinResult() {
  return {
    type: Community.COMMUNITY_JOIN_RESULT
  }
}

export function communityJoinReset() {
  return {
    type: Community.COMMUNITY_JOIN_RESET
  }
}

export function communityGetApplied(communitiyId) {
  return dispatch => {
    axios.get(SG.COMMUNITY_APPLIED_USERS_URL.replace(/:id/, communitiyId), {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(communityGetAppliedResult(res.data.users))
    }).catch(res => {
      dispatch(noticeAdd('承認申請ユーザーのデータを取得出来ませんでした', 'error'))
    })
  }
}

export function communityGetAppliedResult(result) {
  return {
    type: Community.COMMUNITY_GET_APPLIED,
    result: result
  }
}

export function communityGetAppliedReset() {
  return {
    type: Community.COMMUNITY_GET_APPLIED_RESET
  }
}

export function communityUserApprove(communityId, userId) {
  return dispatch => {
    dispatch(loadStart())
    axios.post(SG.COMMUNITY_USER_APPROVE_URL.replace(/:id/, communityId), {
      "user_id": userId
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(noticeAdd(res.data.messages, 'success'))
      dispatch(communityUserApproveResult())
      dispatch(loadEnd())
      }).catch(res => {
      dispatch(noticeAdd('参加承認に失敗しました', 'error'))
      dispatch(loadEnd())
    })
  }
}

export function communityUserBlock(communityId, userId) {
  return dispatch => {
    axios.post(SG.COMMUNITY_BLOCK_URL.replace(/:id/, communityId), {
      "user_id": userId
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
      }).then(res => {
      dispatch(noticeAdd(res.data.messages, 'success'))
      }).catch(res => {
        dispatch(noticeAdd('ユーザーをブロック出来ませんでした', 'error'))
    })
  }
}

export function communityUserReject(communityId, userId) {
  return dispatch => {
    axios.post(SG.COMMUNITY_USER_REJECT_URL.replace(/:id/, communityId), {
      "user_id": userId
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
      }).then(res => {
        dispatch(noticeAdd(res.data.messages, 'success'))
      }).catch(res => {
        dispatch(noticeAdd('参加拒否に失敗しました', 'error'))
    })
 }
}


export function communityUserBlockResult() {
  return {
    type: Community.COMMUNITY_USER_BLOCK
  }
}

export function communityUserApproveResult() {
  return {
    type: Community.COMMUNITY_USER_APPROVE
  }
}

export function communityUserDefect(communityId, userId) {
  return dispatch => {
    dispatch(loadStart())
    axios.post(SG.COMMUNITY_DEFECT_URL.replace(/:id/, communityId), {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(noticeAdd(res.data.messages, 'success'))
      dispatch(getMyJoinedCircle(userId))
      dispatch(loadEnd())
    }).catch(res => {
      dispatch(noticeAdd('脱退に失敗しました', 'error'))
      dispatch(loadEnd())
    })

  }
}

export function communityUserDefectResult(result) {
  return {
    type: Community.COMMUNITY_USER_DEFECT
  }
}

export function communityAllReset() {
  return {
    type: Community.COMMUNITY_ALL_RESET
  }
}


export function checkMyCommunity(circle, currentUser) {
  if (!circle && !!circle.host && !!currentUser && circle.host.id == currentUser.id) {
    return true
  } else {
    return false
  }
}

export function ownerChange(communityId, userId) {
  return dispatch => {
    dispatch(loadStart)
    axios.put(SG.COMMUNITY_OWNER_CHANGE_URL.replace(/:id/, communityId), {
      user_id: userId
    }, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
      }).then(res => {
        dispatch(noticeAdd(res.data.messages, 'success'))
        dispatch(loadEnd())
      }).catch(res => {
        dispatch(noticeAdd(res.response.data.messages, 'error'))
        dispatch(loadEnd())
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/Community.js